export const environment = {
    production: false,
    apiUrl: 'https://now-uat.mgis.com/'
};
